
import { useTranslation } from "react-i18next";

const CheckCard = ({renderer,name, description, description2,description3,iconPath,recommended,secured, navigateTo,isSelected,onSelect}) => {
  
  const { t } = useTranslation();

  const handleSelectedCompany = () => {
    onSelect(navigateTo)
  }

  return (
    renderer && 
        <div className="col-lg-4 mb-3 card-max-width d-flex align-items-stretch mt-4">
            <div className={`az-pay-card ${isSelected ? "selected" : ""} card-max-width card`} onClick={handleSelectedCompany}>

                {  recommended ?
                  <div className={`az-pay-recommended-btn ${isSelected ? "selected" : ""} text-center`}>
                    <span>{t("checkOptions.card.recommended.label")}</span>
                  </div> : secured ? <div className={`az-pay-recommended-btn ${isSelected ? "selected" : ""} text-center`}>
                    <span>{t("checkOptions.card.secured.label")}</span>
                  </div> : null
                }

                <div className={`az-pay-card-title  ${isSelected ? "selected" : ""}`}> 
                    <span className="az-pay-card-icon" ><img src={iconPath} /></span>
                    <span>{name}</span>
                </div>

                <div className={`az-pay-description ${isSelected ? "selected" : ""}`}>
                    {description} 
                    <br/><br/>
                    {description2}<strong>{description3}</strong>
                </div>
               
                
            </div>
        </div>
  );

}
export default CheckCard;
